import { useQuery } from "@tanstack/react-query";
import type { Globals } from "@/features/globals/types/globals.type";
import { fetchStrapiFromClient } from "@/services/strapi-client";

export const useGlobals = () => {
  return useQuery({
    queryKey: ["globals"],
    // Through the Strapi proxy route, not the `getGlobals` Server Action: an
    // action id changes with every build, so a tab opened before a deploy
    // fails with UnrecognizedActionError on its next refetch (Sentry WEB-22A).
    queryFn: async () =>
      (await fetchStrapiFromClient<Globals>("/global-setting")).data ?? null,
    staleTime: 60 * 60 * 1000, // 1 hour
  });
};
